import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import qr from "../../../assets/images/frcsit-qr-code2.png";

const QrPopup = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ position: "relative", padding: "16px 24px 8px" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
          }}
        >
          <i className="icon-cross" style={{ fontSize: "12px" }}></i>
        </IconButton>
        <p
          style={{
            marginBottom: "0px",
            textAlign: "center",
            lineHeight: "25px",
            fontSize: "12px",
          }}
        >
          For membership payment kindly make payment to QR code provided below.
        </p>
      </DialogTitle>
      <DialogContent
        style={{
          display: "flex",
          justifyContent: "center",
          paddingBottom: "20px",
        }}
      >
        <img
          src={qr}
          alt="QR Code"
          style={{ width: "200px", height: "auto" }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default QrPopup;
